<template>
  <div>
    <div class="position-relative">
      <div class="workspace-title">
        Kudos library
      </div>
    </div>
    <b-row>
      <b-col tag="main" lg="12" xl="9" class="mb-4">
        <div class="bg-white shadow-sm p-md-5 p-4">
          <kudos-search-list
            :loading="isKudosLoading"
            :kudos="kudos"
            :received="received"
            class="mt-3"
          >
            <template #tooltip="{ kudo }">
              <kudo-proficient :kudo="kudo" />
            </template>
          </kudos-search-list>
        </div>
      </b-col>
      <b-col lg="12" xl="3">
        <b-row>
          <b-col tag="aside" lg="6" xl="12" class="mb-4">
            <how-kudos-work class="shadow h-100" />
          </b-col>
          <b-col tag="aside" lg="6" xl="12" class="mb-4">
            <ask-recognition class="shadow h-100" />
          </b-col>
        </b-row>
      </b-col>
  </b-row>
 </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { KudosSearchList } from '@/components/KudosList'
import KudoProficient from './KudoProficient'
import { HowKudosWork, AskRecognition } from './Aside'

export default {
  name: 'KudosLibrary',

  computed: {
    ...mapGetters([
      'isKudosLoading',
      'kudos',
      'isUserKudosLoading',
      'meKudosReceived'
    ]),

    received() {
      return this.isUserKudosLoading ? undefined : this.meKudosReceived()
    }
  },

  mounted() {
    this.$store.dispatch('fetchKudosIfNot')
    this.$store.dispatch('fetchMeKudos')
  },

  components: {
    KudosSearchList,
    KudoProficient,
    HowKudosWork,
    AskRecognition
  }
}
</script>
